<p>user-guide works!</p>
